import React, { useState, useEffect } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Collapse,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  Button,
  Box,
} from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { useSelector } from "react-redux"; // Importamos useSelector para acceder al estado de Redux
import apiService from '../../../actions/services';

const ListaOrdenesFabricacion = () => {
  const { user } = useSelector((state) => state.auth); // Accedemos al usuario desde Redux
  const [ordenesFabricacion, setOrdenesFabricacion] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState({}); // Control para las filas expandibles
  const [selectedSala, setSelectedSala] = useState(""); // Estado para la sala seleccionada
  const [fechaInicio, setFechaInicio] = useState(""); // Estado para la fecha de inicio
  const [fechaFin, setFechaFin] = useState(""); // Estado para la fecha de fin

  const tiendasPrecargadas = [
    { id: 1, nombre: "TZ10" },
    { id: 2, nombre: "TPRR" },
    { id: 3, nombre: "TSCR" },
    { id: 4, nombre: "TCSV" },
    { id: 5, nombre: "TMIR" },
    { id: 6, nombre: "TXLA" },
  ];

  // Verificar si el usuario coincide con alguna tienda
  const usuarioCoincideConTienda = tiendasPrecargadas.some((tienda) => tienda.nombre === user.usuario);

  // Efecto para establecer la bodega inicial según el usuario
  useEffect(() => {
    const dat = {};
    apiService.logactivity('visorFabricacionCongelado.jsx','',dat,user);
    const bodegaInicial = tiendasPrecargadas.find((tienda) => tienda.nombre === user.usuario);
    if (bodegaInicial) {
      setSelectedSala(bodegaInicial.nombre); // Establecer la bodega inicial
    }

  }, [user]);

  const fetchData = (sala, fechaIni, fechaFin) => {
    setIsLoading(true); // Indicador de carga
    const datos = {
      Token: "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
      Ambiente: "DESA",
      Dispositivo: {
        Marca: "SAMSUNG",
        Modelo: "S22002B",
        Version: "Android 18.125",
        McAdress: null,
        PowerStatus: "84%",
        WifiStatus: "Conected to iphone de Mauricio",
        GPSStatus: "ON",
        GPS: "321|-485|321",
      },
      Usr: {
        Codigo: "",
        UserNickName: "pierril",
      },
      DatosMetodo: {
        NombreMetodo: "ListarOrdenesFabricacionDocumentosAnexos",
        Datos_Recibidos: `{"FechaIni":"${fechaIni}", "FechaFin":"${fechaFin}","BODEGA":"${sala}"}`,
      },
    };

    const fetchDataUrl = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(
      JSON.stringify(datos)
    )}`;

    fetch(fetchDataUrl)
      .then((response) => response.json())
      .then((data) => {
        try {
          const decodedString = JSON.parse(data.datos_Generados);

          // Parsear las cadenas JSON en DETALLE, ENTRADA y SALIDA_INVENTARIO
          const ordenesParseadas = decodedString.ORDENES_DE_FABRICACION.map((orden) => ({
            ...orden,
            DETALLE: JSON.parse(orden.DETALLE), // Convertir DETALLE a array
            ENTRADA: JSON.parse(orden.ENTRADA), // Convertir ENTRADA a array
            SALIDA_INVENTARIO: JSON.parse(orden.SALIDA_INVENTARIO), // Convertir SALIDA_INVENTARIO a array
          }));

          setOrdenesFabricacion(ordenesParseadas); // Actualizar el estado con los datos parseados
        } catch (error) {
          console.error("Error al procesar datos_Generados:", error);
        }
      })
      .catch((error) => console.error("Error en la solicitud:", error))
      .finally(() => setIsLoading(false));
  };

  const handleExpandClick = (id) => {
    setOpen((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleSalaChange = (event) => {
    setSelectedSala(event.target.value);
  };

  const handleBuscarClick = () => {
    fetchData(selectedSala, fechaInicio, fechaFin);
  };

  return (
    <div>
      <h1>Lista de Órdenes de Envasado</h1>
      <Box display="flex" alignItems="center" gap={2} mb={2}>
        {/* Ocultar el Select de tiendas si el usuario coincide con alguna tienda */}
        {!usuarioCoincideConTienda && (
          <FormControl fullWidth>
            <InputLabel id="sala-select-label">Sala</InputLabel>
            <Select
              labelId="sala-select-label"
              id="sala-select"
              value={selectedSala}
              label="Sala"
              onChange={handleSalaChange}
            >
              {tiendasPrecargadas.map((tienda) => (
                <MenuItem key={tienda.id} value={tienda.nombre}>
                  {tienda.nombre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <TextField
          label="Fecha Inicio"
          type="date"
          value={fechaInicio}
          onChange={(e) => setFechaInicio(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          label="Fecha Fin"
          type="date"
          value={fechaFin}
          onChange={(e) => setFechaFin(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <Button variant="contained" onClick={handleBuscarClick}>
          Buscar
        </Button>
      </Box>
      {isLoading ? (
        <CircularProgress />
      ) : (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Orden ID</TableCell>
              <TableCell>Número Orden</TableCell>
              <TableCell>Fecha Documento</TableCell>
              <TableCell>Comentarios</TableCell>
              <TableCell>Descripcion</TableCell>
              <TableCell>Acción</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {ordenesFabricacion.map((orden) => (
              <React.Fragment key={orden.DocEntry}>
                {/* Fila del encabezado */}
                <TableRow>
                  <TableCell>{orden.DocEntry}</TableCell>
                  <TableCell>{orden.DocNum}</TableCell>
                  <TableCell>{orden.StartDate}</TableCell>
                  <TableCell>{orden.JrnlMemo}</TableCell>
                  
                  <TableCell>
                    <IconButton onClick={() => handleExpandClick(orden.DocEntry)}>
                      {open[orden.DocEntry] ? <ExpandLess /> : <ExpandMore />}
                    </IconButton>
                  </TableCell>
                </TableRow>

                {/* Detalle expandible */}
                <TableRow>
                  <TableCell colSpan={5}>
                    <Collapse in={open[orden.DocEntry]} timeout="auto" unmountOnExit>
                      <Table sx={{ border: "5px solid #ccc", borderRadius: "0px", padding: 0 }}>
                        <TableHead>
                          <TableRow>
                            <TableCell>Código Artículo</TableCell>
                            <TableCell>Descripción</TableCell>
                            <TableCell>Cantidad Planificada</TableCell>
                            <TableCell>Cantidad Emitida</TableCell>
                            <TableCell>Almacén</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {orden.DETALLE.map((detalle, idx) => (
                            <TableRow key={idx}>
                              <TableCell>{detalle.ItemCode}</TableCell>
                              <TableCell>{detalle.ItemName}</TableCell>
                              <TableCell>{detalle.PlannedQty}</TableCell>
                              <TableCell>{detalle.IssuedQty}</TableCell>
                              <TableCell>{detalle.WareHouse}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
};

export default ListaOrdenesFabricacion;